import { connect } from 'react-redux';
import Content from './Content';

const mapStateToProps = ({
  renderOptions: { showPropertyTypes, showTrustPilot },
  system: { isDesktop }
}) => ({
  showPropertyTypes,
  showTrustPilot,
  isDesktop
});

export default connect(mapStateToProps)(Content);
